'use client'

import {
	CONTEXTUAL_MESSAGE_TYPE,
	ContextualMessage,
} from '@fukku/contextual-message'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { ProductDisclaimer } from 'product/types/Product'
import { useEffect } from 'react'
import { cx } from 'utils/cx'
import { useAnalytics } from '../../../contexts/AnalyticsProvider/AnalyticsProvider'

import styles from './SizeDisclaimer.module.css'

const sizeDisclaimerKey = {
	[ProductDisclaimer.UP_DISCLAIMER]:
		'product.sizeSelector.smallSizing.helpmessage',
	[ProductDisclaimer.DOWN_DISCLAIMER]:
		'product.sizeSelector.bigSizing.helpmessage',
	[ProductDisclaimer.SIZEGUIDE_DISCLAIMER]:
		'product.sizeSelector.helpSize.sizeguide.text',
	[ProductDisclaimer.MATERNITY_DISCLAIMER]:
		'product.sizeSelector.helpSize.maternity.text',
}

interface SizeDisclaimerProps {
	readonly disclaimer?: ProductDisclaimer
	readonly className?: string
}

export function SizeDisclaimer({
	disclaimer,
	className,
}: SizeDisclaimerProps): React.ReactNode {
	const { t } = useLabels()
	const { sendShowDisclaimerSizeEvent } = useAnalytics()

	useEffect(() => {
		if (disclaimer) {
			sendShowDisclaimerSizeEvent()
		}
	}, [disclaimer])

	return disclaimer ? (
		<ContextualMessage
			className={cx(styles.sizeDisclaimer, className)}
			type={CONTEXTUAL_MESSAGE_TYPE.INFO}
			message={t(sizeDisclaimerKey[disclaimer])}
		/>
	) : null
}
